import React, { useState, useEffect } from 'react';
import { Plus, RefreshCw } from 'lucide-react';
import { getCostCenters, createCostCenter } from '../../api/erp';
import { toast } from 'react-toastify';

const CostCentersPage = () => {
  const [centers, setCenters] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showModal, setShowModal] = useState(false);
  const [formData, setFormData] = useState({ code: '', name: '', type: 'cost', description: '' });

  useEffect(() => {
    fetchData();
  }, []);

  const fetchData = async () => {
    setLoading(true);
    try {
      const data = await getCostCenters();
      setCenters(data);
    } catch (error) {
      toast.error('Failed to load cost centers');
    } finally {
      setLoading(false);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      await createCostCenter(formData);
      toast.success('Created successfully');
      setShowModal(false);
      fetchData();
    } catch (error) {
      toast.error('Failed to create');
    }
  };

  return (
    <div className="p-6">
      <div className="flex justify-between mb-6">
        <h1 className="text-2xl font-bold">Cost & Profit Centers</h1>
        <button onClick={() => setShowModal(true)} className="flex items-center gap-2 bg-black text-white px-4 py-2 rounded">
          <Plus size={16} /> New Center
        </button>
      </div>

      <div className="bg-white rounded shadow overflow-hidden">
        <table className="w-full">
          <thead className="bg-gray-50">
            <tr>
              <th className="px-6 py-3 text-left">Code</th>
              <th className="px-6 py-3 text-left">Name</th>
              <th className="px-6 py-3 text-left">Type</th>
              <th className="px-6 py-3 text-left">Description</th>
            </tr>
          </thead>
          <tbody>
            {centers.map(c => (
              <tr key={c.id} className="border-t">
                <td className="px-6 py-4">{c.code}</td>
                <td className="px-6 py-4 font-medium">{c.name}</td>
                <td className="px-6 py-4 capitalize">{c.type}</td>
                <td className="px-6 py-4 text-gray-500">{c.description}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {showModal && (
        <div className="fixed inset-0 bg-black/50 flex items-center justify-center p-4">
          <div className="bg-white rounded p-6 w-full max-w-md">
            <h2 className="text-xl font-bold mb-4">New Cost Center</h2>
            <form onSubmit={handleSubmit} className="space-y-4">
              <input 
                placeholder="Code" 
                className="w-full border p-2 rounded"
                value={formData.code}
                onChange={e => setFormData({...formData, code: e.target.value})}
                required
              />
              <input 
                placeholder="Name" 
                className="w-full border p-2 rounded"
                value={formData.name}
                onChange={e => setFormData({...formData, name: e.target.value})}
                required
              />
              <select 
                className="w-full border p-2 rounded"
                value={formData.type}
                onChange={e => setFormData({...formData, type: e.target.value})}
              >
                <option value="cost">Cost Center</option>
                <option value="profit">Profit Center</option>
              </select>
              <textarea 
                placeholder="Description" 
                className="w-full border p-2 rounded"
                value={formData.description}
                onChange={e => setFormData({...formData, description: e.target.value})}
              />
              <div className="flex gap-2 justify-end">
                <button type="button" onClick={() => setShowModal(false)} className="px-4 py-2 border rounded">Cancel</button>
                <button type="submit" className="px-4 py-2 bg-black text-white rounded">Create</button>
              </div>
            </form>
          </div>
        </div>
      )}
    </div>
  );
};

export default CostCentersPage;
